{
  "400": {
    "forbidden": "Interdit",
    "forbidden_desc": "Vous n'avez pas accès à cette page, veuillez contacter votre fleet manager.",
    "forbidden_note": "(La synchronisation des droits peut prendre jusqu'à 30 minutes.)",
    "log_out": "Se déconnecter",
    "retry": "Réessayer"
  },
  "404": {
    "back_button": "Retourner vers aperçu",
    "contact_support": "Contacter le Support",
    "go_home": "Retournez à la page d'accueil",
    "not_found": "Page non trouvée",
    "not_found_description": "La page que vous cherchez a été supprimée, son nom a été changé ou elle est temporairement indisponible.",
    "text": "Si vous pensez que c'est incorrect, veuillez envoyer un message à",
    "title": "Cette page n'est plus disponible."
  },
  "administration": {
    "billing": {
      "billing_details": "Détails de facturation",
      "bus": "Boîte",
      "city": "Commune",
      "city_required": "Commune est obligatoire",
      "company_name": "Nom de l'entreprise",
      "country": "Pays",
      "edit_billing_details": "Changer les détails de facturation",
      "edit_method": "Modifier les détails",
      "email_address": "adresse e-mail",
      "name_required": "Nom est obligatoire",
      "nr": "N°",
      "nr_required": "N° est obligatoire",
      "postal_code": "Code postal",
      "postal_required": "Code postal est obligatoire",
      "save_details": "Sauvegarder les détails de facturation",
      "save_method": "Enregistrer les détails",
      "street": "Rue",
      "street_required": "Rue est obligatoire",
      "vat": "TVA"
    },
    "invoices": {
      "no_invoice_rights": "Vous n'avez pas les droits pour consulter les factures. Veuillez contacter votre administrateur.",
      "partial_load": "Certaines factures n'ont pas pu être chargées",
      "downloaddetails": "Télécharger les CDR Télécharger le résumé des détails",
      "downloaddetailscsv": "Télécharger le résumé des détails en CSV",
      "actions": "Actes",
      "amount": "Montant",
      "columns": {
        "date_range": "Date",
        "invoice_nr": "Factures Nr",
        "status": "Statut"
      },
      "date": "Date",
      "download": "Télécharger la facture",
      "downloadattachment": "Télécharger les CDR",
      "due_date": "Date d'échéance",
      "invoice_date": "Date de facture",
      "invoice_nr": "N° de facture",
      "invoice_page": "Résumé des factures",
      "no_invoices_found": "Aucune facture trouvée",
      "open": "Ouvrir",
      "open_amount": "Montant impayé",
      "pay_invoice": "Payer la facture",
      "payment_status": {
        "open": "Ouvrir",
        "paid": "Payee",
        "pending": "En cours"
      },
      "status": "statut",
      "total": "Total"
    },
    "order": {
      "actions": "actes",
      "activate_sim": "Activer une carte SIM",
      "activate_sim_now": "Activer la carte SIM maintenant",
      "active": "Actif",
      "approve_installation": "Approuver l'installation",
      "available_sims": "SIMS disponibles:",
      "bulk": {
        "address_title": "Adresse de livraison",
        "amount": "quantité",
        "amount_label": "quantité",
        "beneficiary": "Bénéficiaire",
        "btn_place": "Passer la commande",
        "confirm_message": "Vous êtes sur le point de commander {amount} cartes SIM. Êtes-vous sûr ? Veuillez vérifier les détails ci-dessous :",
        "max_error": "La quantité doit être égale ou inférieure à {max}",
        "min_error": "La quantité doit être égale ou supérieure à {min}",
        "order_title": "Commande en gros de cartes SIM",
        "success_message": "Merci pour votre demande. Les cartes SIM seront envoyées par courrier.",
        "title_confirm": "Confirmer la commande"
      },
      "bulk_order_sim": "Commande en gros de cartes SIM",
      "create_ticket": "Créer un ticket",
      "customer_nr": "n° client",
      "date": "date",
      "description": "Description",
      "download": "Télécharger",
      "download_pdf": "Télécharger le pdf",
      "ended": "résilié",
      "filter": "Rechercher ...",
      "id": "ID",
      "included_options": "Options incluses",
      "installation_date": "Date d'installation prévue :",
      "invoice_address": "Adresse de facturation",
      "invoice_customer": "Client de facturation",
      "no_order_found": "Aucune commande trouvée",
      "offer": "devis",
      "offerte": "devis",
      "order": "Commande",
      "order_date": "Date de commande",
      "order_id": "N° de commande",
      "order_new_sim": "Commander de nouvelles cartes SIM",
      "order_new_subscription": "Commander un nouvel abonnement",
      "order_overview": "Résumé de commande",
      "partner": "Partenaire",
      "pending": "en attente",
      "pending_action": "Action en attente",
      "select_sim": "Sélectionnez une carte SIM dans la liste ci-dessous",
      "status": "statut",
      "statuses": {
        "awaiting": "En attente de l'achèvement de l'exécution",
        "fullfilled": "Exécuté",
        "installation": "Installation",
        "ordered": "Devis",
        "processed": "En attente d'approbation",
        "shipped": "En attente de l'initiation de l'exécution"
      }
    },
    "usage": "Détails d'utilisation"
  },
  "cards": {
    "Download_our_citymesh_connect_app": "Téléchargez notre app Citymesh Connect",
    "above_average": " au-dessus de la moyenne",
    "available": "Disponible",
    "below_average": " au-dessous de la moyenne",
    "by_email": "par e-mail",
    "by_post": "par la poste",
    "call": "Appel",
    "called": "appelé",
    "calling": "Appeler",
    "cease_your_subscription": "Résilier votre abonnement",
    "change_your_internet": "Changer votre connexion internet",
    "chromecast_smart_tv": "Regarder la télé en ligne avec Google Chromecast",
    "company": "Entreprise",
    "data_mb": "Data (MB)",
    "days_left": "jours",
    "details": "Détails",
    "disabled": "Désactivé",
    "enabled": "Activé",
    "fiber_content": "La fibre optique, l'Internet du futur",
    "in_bundle": "Dans forfait",
    "international": "International",
    "internet_speed": "De quelle vitesse internet avez-vous besoin",
    "invoice_reminders": "Rappels de facture",
    "is_due": "à payer",
    "method": "Détails",
    "mobile_data": "Data mobile",
    "mobile_usage": "Consommation mobile",
    "month": "mois",
    "more_info": "Plus d'infos",
    "move_your_internet": "Déménager votre connexion internet",
    "nat_eu": "National + UE",
    "no": "Non",
    "only_change_request": "Ces données ne peuvent être changées que sur demande",
    "open_amount": "Montant impayé",
    "out_of_bundle": "Hors forfait",
    "pay_now": "Payer",
    "payment_services": "Services payants",
    "peppol": "Peppol",
    "peppol_active": "par Peppol",
    "peppol_id": "Identifiant Peppol",
    "premium": "Premium",
    "prevent_losing_time": "Perdre Internet, perdre du temps et de l'argent",
    "roaming_out": "Roaming (hors UE)",
    "select_usage_type": "Sélectionner le type de consommation",
    "sent": "envoyé",
    "sepa_desc": "Payez vos factures par domiciliation pour vous assurer de ne jamais manquer une facture.",
    "settings": "Paramètres",
    "shortcuts": "Raccourcis",
    "slip_your_bill": "N'oubliez pas vos factures",
    "speedtest": "Test de vitesse",
    "stay_in_the_know": "Rester au courant",
    "tips_tricks": "Conseils & astuces",
    "total_out_of_bundle_cost": "Coût total hors forfait",
    "usage": "consommation",
    "usage_history": "l'historique de la consommation",
    "usage_statistics": "Statistiques de consommation",
    "usage_type": "Type de consommation",
    "used": "consommé",
    "voice_min": "Voice (min)",
    "wifi6_ready": "WiFi6, la nouvelle norme!",
    "yes": "Oui"
  },
  "countries": {
    "belgium": "Belgique",
    "france": "France",
    "germany": "Allemagne",
    "luxembourg": "Luxembourg",
    "netherlands": "Pays-Bas"
  },
  "customer": {
    "ID": "ID"
  },
  "customer_select": {
    "select_customer": "Veuillez selectionner un client"
  },
  "dashboard": {
    "Welcome back": "Bienvenue",
    "leaderboard": {
      "cost": "Coût",
      "name": "Nom",
      "rank": "Classement",
      "title": "Top 5 Utilisateurs",
      "usageOrder": {
        "Cost": "Coût",
        "Volume": "Volume"
      },
      "usageType": {
        "MOBILE_DATA_BELGIUM": "Données Mobiles Belgique",
        "MOBILE_DATA_ROAMING_EU": "Données Mobiles Roaming UE",
        "MOBILE_DATA_ROAMING_ROW": "Données Mobiles Roaming Reste du Monde",
        "SMS_BELGIUM": "SMS Belgique",
        "SMS_PREMIUM": "SMS Premium",
        "SMS_ROAMING_EU": "SMS Roaming UE",
        "SMS_ROAMING_ROW": "SMS Roaming Reste du Monde",
        "SMS_TO_INTERNATIONAL": "SMS vers International",
        "VOICE_BELGIUM": "Voix Belgique",
        "VOICE_INTERNATIONAL": "Voix vers International",
        "VOICE_PREMIUM": "Voix Premium",
        "VOICE_ROAMING_EU": "Voix Roaming UE",
        "VOICE_ROAMING_ROW": "Voix Roaming Reste du Monde"
      },
      "volume": "Volume"
    },
    "products": {
      "title": "Vos abonnements ou lignes"
    }
  },
  "error": {
    "customer_select_title": "Demande non valable",
    "unknown_customer_id": "Oups, nous n'avons pas pu traiter cette demande. Veuillez sélectionner un client. Vous pouvez alterner entre clients via le menu en haut à droite.",
    "wrong_customer_id_redirect": "Oups, nous n'avons pas pu traiter cette demande."
  },
  "filter": {
    "add_filter": "Ajouter filtre",
    "contains": "contient",
    "is": "est",
    "is_after": "est après",
    "is_before": "est avant",
    "is_not": "n'est pas",
    "range": "plage de date",
    "status": {
      "1": "En cours",
      "2": "En suspens",
      "3": "Complété",
      "4": "Suivi",
      "21": "Faire",
      "22": "Réponse du client nécessaire",
      "Completed": "Complété",
      "Customer reply needed": "Réponse du client nécessaire",
      "CustomerReplyNeeded": "Réponse du client nécessaire",
      "Follow up": "Suivi",
      "FollowUp": "Suivi",
      "In progress": "En cours",
      "InProgress": "En Cours",
      "On hold": "En suspens",
      "OnHold": "En Suspens",
      "Open": "Ouvrir",
      "Paid": "Payé",
      "To do": "Faire",
      "ToDo": "Faire",
      "open": "Ouvrir",
      "paid": "Payé"
    }
  },
  "global": {
    "activate": "Activer",
    "active": "Active",
    "cancel": "Annuler",
    "cancelled": "annulé",
    "click_for_details": "Cliquer pour plus de détails",
    "click_to_hide": "Cliquer pour réduire",
    "close": "Fermer",
    "confirm": "Confirmer",
    "confirm_title": "Êtes-vous sûr ?",
    "connection_error_message": "Nous ne parvienons pas à établir de connexion avec Citymesh.com",
    "connection_error_title": "Pas de connexion",
    "cookie_policy": "Politique en matière de cookies",
    "day": "jour",
    "deactivate": "Désactiver",
    "email_required": "Adresse e-mail obligatoire",
    "email_valid": "Adresse e-mail doit être valable",
    "fetching": "Récupération",
    "general_conditions": "Conditions générales",
    "go_to_page": "Aller à la page",
    "inactive": "Non actif",
    "loading": "Chargement",
    "month": "mois",
    "no_results": "Aucune donnée disponible",
    "of": "sur",
    "ok": "Ok",
    "online": "en ligne",
    "pending": "en attente",
    "powered_by": "Propulsé par",
    "privacy_policy": "Politique de confidentialité",
    "required_field": "champ obligatoire",
    "results": "résultats",
    "retry_connection": "Réessayer la connexion",
    "showing": "Affichage de",
    "invalid_phone_format": "numéro de téléphone invalide",
    "invalid_email": "adresse e-mail invalide"
  },
  "language": {
    "French": "Français",
    "dutch": "Néerlandais",
    "english": "Anglais"
  },
  "language_selector": {
    "language": "Langue"
  },
  "menu": {
    "404": "404",
    "auth": "Auth",
    "billing": "Facturation",
    "buttons": "Bouton",
    "dashboard": "Tableau de bord",
    "faq": "FAQ",
    "home": "Accueil",
    "login": "Login",
    "payment-methods": "Options de paiement",
    "payments": "Paiements",
    "preferences": "Préférences de compte",
    "pricing-plans": "Plans tarifaires",
    "projects": "Projets",
    "recover-password": " Récupération du mot de passe",
    "recover-password-email": "Adresse e-mail pour récupération du mot de passe",
    "settings": "Paramètres de l'application",
    "signup": "Souscrire",
    "timelines": "Chronologies",
    "users": "Utilisateurs"
  },
  "menu_side": {
    "administration": "Administration",
    "billing": "Facturation",
    "home": "Accueil",
    "internet": "Internet",
    "invoices": "Factures",
    "mind": "Mind",
    "mindinvoices": "Factures",
    "mobile": "Mobile",
    "orders": "Commandes",
    "overview": "Aperçu",
    "products": "Produits",
    "support": "Support",
    "unauthorized": "403",
    "usermanagement": "Gestion des utilisateurs",
    "usage": "Consommation"
  },
  "message": {
    "usage_history": "L'historique de consommation"
  },
  "order": {
    "require_sim_select_error": "Aucune carte SIM sélectionnée"
  },
  "partner": {
    "addresstool": {
      "name": "nom du client",
      "title": "Outils partenaires",
      "warning": "Les vitesses indiquées vous sont uniquement fournies à titre indicatif. Elles ne revêtent aucune valeur contractuelle.",
      "box": "Boîte",
      "city": "Ville",
      "expectedfiber": "Vitesses fibre attendues :",
      "expectedinternet": "Vitesses internet attendues :",
      "fiber": "GPON",
      "invalid_request": "Requête invalide",
      "internet": "VDSL",
      "linetest": "Test de ligne",
      "maxdownload": "Vitesse de téléchargement max :",
      "maxspeed": "Vitesse maximale :",
      "maxupload": "Vitesse d'envoi max :",
      "nodata": "Aucune donnée trouvée pour cette adresse",
      "technology_not_available": "Désolé, la technologie demandée n'est pas disponible à cette adresse. Veuillez essayer la vérification d'adresse Coax ou Fiber.",
      "number": "Numéro",
      "result": "Votre Résultat",
      "run": "Lancer",
      "street": "Rue",
      "validation": {
        "invalid_city": "Nom de ville invalide",
        "invalid_format": "Format invalide (utilisez des lettres ou des symboles communs)",
        "invalid_number": "Numéro de maison invalide",
        "invalid_zip": "Format de code postal invalide",
        "numeric_only": "Ce champ ne doit contenir que des chiffres",
        "required": "Ce champ est obligatoire"
      },
      "zipcode": "Code postal",
      "ticket_created": "Le ticket {id} a été créé. Nous vous répondrons dans les 5 jours.",
      "customerName": "Nom du client"
    },
    "agreements": {
      "title": "Accords",
      "upload": "télécharger"
    },
    "commissions": {
      "csv": "csv",
      "pdf": "pdf",
      "title": "Aperçu des commissions"
    },
    "deals": {
      "upload_contract": "Téléverser le contrat",
      "select_contract": "Sélectionner le contrat",
      "upload": "Téléverser",
      "upload_contract_required": "Veuillez sélectionner un contrat",
      "upload_contract_invalid_type": "Seuls les fichiers PDF, PNG, JPG et JPEG sont autorisés",
      "upload_contract_too_large": "Le contrat ne peut pas dépasser 20 Mo",
      "upload_contract_size": "{size}/{max} Mo",
      "upload_contract_success": "Téléversement réussi",
      "upload_contract_failed": "Échec du téléversement",
      "action": "action",
      "address": "adresse",
      "company": "entreprise",
      "companynr": "Numéro d'entreprise",
      "date": "date",
      "deal_overview": "Aperçu de l'enregistrement de l'opportunité",
      "deals": "contrats",
      "description": "Commentaires",
      "email": "e-mail",
      "file": "Fichiers",
      "register": "S'inscrire",
      "firstname": "Prénom du prospect",
      "lastname": "Nom du prospect",
      "name": "nom",
      "new_claim": "Nouvelle opportunité",
      "new_deal": "Enregistrer l'opportunité",
      "phonenumber": "numéro de téléphone",
      "reason": "Raison",
      "solution": "Solution",
      "solution_other": "Autre solution",
      "solution_options": {
        "mobile": "Mobile",
        "internet": "Internet",
        "ucaas": "UCaaS",
        "fixed_telephony": "Téléphonie fixe",
        "other": "Autre"
      },
      "status": "statut",
      "statuses": {
        "requested": "Demandé",
        "active": "Actif",
        "pending": "En attente",
        "expired": "Expiré",
        "won": "Gagné",
        "rejected": "Rejeté",
        "cancelled": "Annulé"
      },
      "submit": "créer une nouvelle réclamation",
      "ticket": "ticket",
      "info_succes": "réclamation réussie",
      "info_fail": "échec de la réclamation",
      "dealid": "ID de réclamation",
      "title_success": "Opportunité enregistrée avec succès",
      "title_fail": "Échec de l'enregistrement de l'opportunité",
      "cancel": "Annuler l'opportunité",
      "cancel?": "Êtes-vous sûr de vouloir annuler cette opportunité ?",
      "cancel_success": "Opportunité annulée avec succès",
      "claimed_until": "réclamé jusqu'au",
      "close": "Fermer",
      "confirm": "Confirmer",
      "nodeals": "Aucun contrat trouvé"
    },
    "documents": {
      "filter": {
        "contract": "Contrat",
        "marketing": "Marketing",
        "pricelist": "Liste de prix",
        "productsheet": "Fiche produit",
        "none": "Aucun",
        "general": "General",
        "other": "Autre"
      },
      "contracttemplates": "Modèles de contrat",
      "documents": "Mes Documents",
      "pricelists": "Listes de prix",
      "productlists": "Listes de produits",
      "submit": "soumettre",
      "title": "Mes Documents",
      "file": "Fichier",
      "filetype": "Type de fichier",
      "type": "Type",
      "doctype": {
        "general": "Général",
        "personal": "Personnel"
      },
      "category": "Catégorie",
      "date": "Date",
      "action": "Action",
      "nodocs": "Aucun document trouvé"
    }
  },
  "userManagement":{
    "noUsers": "Aucun utilisateur trouvé",
    "userEmail": "E-mail",
    "userFullName": "Nom complet",
    "userRole": "Rôle",
    "userStatus": "Statut",
    "userInvitedOn": "Invité le",
    "userLastLoggedIn": "Dernière connexion",
    "userSplitBilling": "Facturation séparée",
    "actions": "Actes",
    "resendInvite": "Renvoyer l'invitation",
    "userReinviteSent": "Reinvitation envoyée avec succès",
    "userReinviteFailed": "Échec de l'envoi de la reinvitation",
    "inviteNewUser": {
      "inviteUserTitle": "Inviter un utilisateur",
      "userEmail": "E-mail",
      "userFirstName": "Prénom",
      "userLastName": "Nom",
      "userLanguage": "Langue",
      "userRole": "Rôle",
      "inviteUserButton": "Inviter un utilisateur",
      "inviteUserSuccess": "Utilisateur invité avec succès.",
      "fleetManagerRole": "Gestionnaire de flotte",
      "simManagerRole": "Gestionnaire SIM",
      "invoiceManagerRole": "Gestionnaire de facturation",
      "endUserRole": "Utilisateur final",
      "missingCredentials": "Les identifiants d’authentification sont manquants ou invalides.",
      "insufficientPermissions": "Vous n’avez pas l’autorisation de créer des utilisateurs.",
      "userAlreadyExists": "Un compte associé à cette adresse e-mail existe déjà auprès du fournisseur d’identité.",
      "wrongEmailFormat": "Le format de l’adresse e-mail est invalide.",
      "unexpectedServerError": "Erreur serveur inattendue.",
      "languageEn": "Anglais",
      "languageNl": "Néerlandais",
      "languageFr": "Français",
      "editUserTitle": "Modifier l'utilisateur",
      "editUserSuccess": "Utilisateur mis à jour avec succès.",
      "editUserFailed": "Échec de la mise à jour de l'utilisateur."
    }
  },
  "payment": {
    "btn_ok": "OK",
    "info_fail": "Nous n'avons pas reçu votre paiement. Veuillez réessayer ou contacter notre service de support.",
    "info_success": "Nous avons bien reçu votre paiement. Notez que la mise à jour du montant dû peut prendre jusqu'à 30 minutes.",
    "title_fail": "Échec du paiement",
    "title_success": "Paiement reçu"
  },
  "product": {
    "barrings": {
      "title": "Interdictions"
    },
    "mobile": {
      "options": "Options"
    },
    "usage_warnings": {
      "title": "Alertes de consommation"
    }
  },
  "products": {
    "active": "Actif",
    "cancelled": "annulé",
    "filter": "Rechercher ...",
    "inactive": "Inactif",
    "internet": {
      "actions": "actions",
      "address": "adresse",
      "available": "Disponible",
      "bus": "Boîte",
      "circuit_id": "Circuit id",
      "connection": "connexion",
      "connection_interrupted": "Votre connexion internet sera interrompue pour quelques secondes quand l'IPv6 est activé.",
      "details": "Détails",
      "down": "Descendant",
      "enable_ipv6": "Activer IPv6",
      "internet_overview": "Résumé Internet",
      "internet_usage": "Consommation Internet",
      "ip": "IPv4",
      "label": "label",
      "no_internet_found": "Aucun abonnement Internet trouvé",
      "password": "Mot de passe",
      "password_modem": "Si vous changez votre mot de passe, n'oubliez pas à le changer dans la configuration de votre routeur.",
      "profile": "Profile",
      "select_subscriber": "Selectionner un abonné",
      "settings": "Paramétres",
      "start": "Départ",
      "status": "statut",
      "subscription": "abonnement",
      "type": "Type",
      "up": "Ascendant",
      "usage_statistics": "Statistiques de consommation",
      "username": "Nom d'utilisateur"
    },
    "internet_usage": "Consommation Internet",
    "mobile": {
      "esim": "eSIM",
      "psim": "SIM physique",
      "simtype": "SIM type",
      "IMSI_number": "Numéro SIM",
      "actions": "actions",
      "activate_calls_prem_numbers": "Appels vers les services premium possibles",
      "activate_inter_calls": "Appels internationaux possibles",
      "activate_out_of_bundle_sms": "Activer les SMS hors forfait",
      "activate_prem_numbers": "Activer les appels vers les numéros premium",
      "activating_option": "Nous activons l'option, cela peut prendre un moment…",
      "activation_date": "Date d'activation",
      "activation_success_reference": "Référence de commande : {orderId}",
      "activation_success_title": "Option activée avec succès",
      "addon_2292": "Sur le réseau Citymesh, vous pourrez toujours profiter des meilleures vitesses 4G et 5G.<br />À ce jour, nous ne pouvons pas encore couvrir l’ensemble du pays avec notre propre réseau.<br />Si vous souhaitez également bénéficier de la 5G sur le réseau de notre partenaire Proximus, <strong>veuillez souscrire une option 5G. </strong><br /><a href=\"https://www.citymesh.be/fr/reseau-et-service/\" target=\"_blank\">Plus d’informations sur le réseau Citymesh.</a>",
      "addon_2294": "Sur le réseau Citymesh, vous pourrez toujours profiter des meilleures vitesses 4G et 5G.<br />À ce jour, nous ne pouvons pas encore couvrir l’ensemble du pays avec notre propre réseau.<br />Si vous souhaitez également bénéficier de la 5G sur le réseau de notre partenaire Proximus, <strong>veuillez souscrire une option 5G. </strong><br /><a href=\"https://www.citymesh.be/fr/reseau-et-service/\" target=\"_blank\">Plus d’informations sur le réseau Citymesh.</a>",
      "addon_2295": "Sur le réseau Citymesh, vous pourrez toujours profiter des meilleures vitesses 4G et 5G.<br />À ce jour, nous ne pouvons pas encore couvrir l’ensemble du pays avec notre propre réseau.<br />Si vous souhaitez également bénéficier de la 5G sur le réseau de notre partenaire Proximus, <strong>veuillez souscrire une option 5G. </strong><br /><a href=\"https://www.citymesh.be/fr/reseau-et-service/\" target=\"_blank\">Plus d’informations sur le réseau Citymesh.</a>",
      "amount": "montant",
      "bundle_name": "Nom du pack",
      "confirm_activate": "Ceci activera son abonnement mobile. En êtes-vous sûr ?",
      "confirm_activate_option": "Ceci activera l'option {name}, ce qui ajoutera des frais de {price} à votre abonnement mensuel",
      "confirm_activate_option_title": "Êtes-vous sûr ?",
      "confirm_deactivate": "Ceci désactivera cet abonnement mobile. Il ne sera plus utilisable. En êtes-vous sûr ?",
      "confirm_deactivate_option": "Ceci désactivera l'option {name}, ce qui supprimera les frais de {price} de votre abonnement mensuel",
      "confirm_sim_swap": "Vous êtes sur le point de demander un échange de carte SIM. Nous vous enverrons une nouvelle carte SIM pour remplacer votre carte actuelle. En êtes-vous sûr ?",
      "confirm_suspend": "Ceci suspendra temporairement cet abonnement mobile. Il ne sera plus utilisable. En êtes-vous sûr ?",
      "details": "Détails",
      "end_date": "date de fin",
      "fist_warning_sms": "1er avertissement par SMS sur",
      "gb_data": "GB DATA",
      "id": "n°",
      "info_out_of_bundle": "Vous avez actuellement dépassé votre limite de {amount}. Essayez de réduire votre consommation de données.",
      "info_reach_bundle": "Vous êtes sur le point d'atteindre votre limite. Essayez de réduire votre consommation de données.",
      "label": "label",
      "limits": "Limites",
      "minutes": "Minutes",
      "mobile_data": "Data mobile",
      "mobile_data_usage": "Consommation data mobile",
      "mobile_overview": "Résumé mobile",
      "mobile_phone_number": "Numéro GSM",
      "msisdn": "MSISDN",
      "no_mobile_subscription": "Aucun abonnement mobile trouvé",
      "no_subscription_found": "Aucun abonnement mobile trouvé",
      "out_of_bundle_cost": "Montant hors forfait",
      "phone_from": "Appel de",
      "price": "Prix",
      "puk1": "PUK1",
      "puk2": "PUK2",
      "request_failed": "Échec de l'envoi de la demande",
      "request_success": "Demande envoyée avec succès",
      "temporarily_unavailable": "Temporairement indisponible",
      "no_order_permission": "Vous n'avez pas l'autorisation de commander des options.",
      "order_in_progress": "Commande en cours",
      "order_in_progress_blocked": "Une commande d'option est encore en cours. Vous pourrez commander une nouvelle option une fois celle-ci terminée.",
      "second_warning_sms": "2ème avertissement par SMS sur",
      "settings": "Paramètres",
      "settings_updated": "Paramétres mises à jour",
      "simnumber": "Sim Nr",
      "sms": "SMS",
      "split_bill_status": "Statut de la facture partagée",
      "split_bill_type": "Type de facture partagée",
      "start_date": "date de début",
      "status": "statut",
      "subscription": "Abonnement",
      "subscription_name": "Nom d'abonnement",
      "suspend": "Suspendre",
      "termination_date": "Date de termination",
      "text_copied": "texte copié!",
      "unlimited": "∞",
      "update_settings": "Mettre à jour les paramétres",
      "upgrade": "Changer d'abonnement",
      "usage_warnings": "Avertissement de consommation"
    },
    "pending": "en attente",
    "status": {
      "Created": "Créé",
      "Ended": "Terminé",
      "Fulfilled": "Exécuté",
      "OrderCancelled": "Commande annulée",
      "OrderRejected": "Commande rejetée",
      "QuotationRejected": "Devis rejeté",
      "Removed": "Supprimé",
      "WaitingForCleanupApproval": "En attente d'approbation du nettoyage",
      "WaitingForCleanupCompletion": "En attente de la fin du nettoyage",
      "WaitingForCleanupInitiation": "En attente du début du nettoyage",
      "WaitingForFulfillmentCompletion": "En attente de la fin de l'exécution",
      "WaitingForFulfillmentInitiation": "En attente du début de l'exécution",
      "WaitingForOrderApproval": "En attente d'approbation de commande"
    },
    "status_group": {
      "Active": "Actif",
      "Inactive": "Inactif",
      "Terminated": "Résilié"
    },
    "support": {
      "export_all": "Tous les tickets",
      "export_filtered": "Tickets filtrés"
    },
    "terminated": "Terminé",
    "usage_details": "Consommation"
  },
  "sim_swap": "Remplacer",
  "support": {
    "Field_is_required": "Champs obligatoire",
    "You": "Vous",
    "archived": "Archivé",
    "attachments": "Annexes",
    "category": "Catégorie",
    "chat_with_us": "Chattez avec nous!",
    "citymesh_support": "Citymesh Support",
    "closed_on": "Fermé le",
    "commercial": "Service commercial",
    "create_ticket": "Créer un ticket",
    "created_by": "Créé par",
    "date": "Date de création",
    "default": "Par défaut",
    "department": "Département",
    "export": "Exportation",
    "file_too_large": "Fichier \"{fileName}\" est trop lourd. Taille maximale du fichier est {maxSize} MB.",
    "filter": "Cherchez",
    "finance": "Comptabilité",
    "helpdesk": "Helpdesk",
    "label": "Label",
    "message": "Message",
    "monitor_connections": "Network Monitoring",
    "new_support_ticket": "Nouveau ticket",
    "no_product": "Aucun",
    "no_support": "Aucun ticket trouvé",
    "order": "Commande",
    "other": "Autre",
    "priorities": {
      "p1": "Urgent (P1)",
      "p2": "Élevé (P2)",
      "p3": "Moyen (P3)",
      "p4": "Faible (P4)"
    },
    "priority": "Priorité",
    "priority_number": {
      "1": "P1",
      "2": "P2",
      "3": "P3",
      "4": "P4"
    },
    "product": "Produit",
    "resolution": "Resolution",
    "search_option": "Selectionner une option",
    "select_column": "Sélectionner une colonne",
    "select_operator": "Sélectionner un opérateur",
    "select_option": "Selectionner une option",
    "select_value": "Sélectionner une valeur",
    "send": "Envoyer",
    "status": "Statut",
    "subject": "Sujet",
    "support_ticket": "Ticket Support",
    "ticket": {
      "info_fail": "Un problème est survenu lors de la création de votre ticket, veuillez réessayer plus tard",
      "info_success": "Votre ticket est créé",
      "p1_contact": "Vous avez créé un ticket prioritaire: appelez nous au +32 2 580 91 00 afin que nous puissions traiter votre ticket immédiatement",
      "ticket_number": "Numéro ticket",
      "title_fail": "Impossible de créer un ticket",
      "title_success": "Ticket créé"
    },
    "ticketId": "TicketID",
    "ticket_id": "ticket id",
    "ticket_status": {
      "1": "En cours",
      "2": "En pause",
      "3": "Résolu",
      "4": "En suivi",
      "21": "To Do",
      "22": "En attente de réponse",
      "Completed": "Résolu",
      "Customer reply needed": "En attente de réponse",
      "Follow up": "En suivi",
      "In progress": "En cours",
      "On hold": "En pause",
      "To do": "To Do"
    },
    "time": {
      "day": "jour",
      "hour": "h",
      "month": "mois",
      "week": "semaine",
      "year": "année"
    },
    "time_opened": "TTR",
    "time_opened_tooltip": "Temps avant résolution",
    "times": {
      "day": "jours",
      "month": "mois",
      "week": "semaines",
      "year": "années"
    },
    "total_size_too_large": "Dépassement de la taille maximale autorisée pour les fichiers combinés",
    "unsupported_file": "Fichier \"{fileName}\" n'est pas supporté",
    "unsupported_file_type": " Type fichier \"{fileName}\" non pris en charge.  Types de fichiers autorisés sont: {allowedTypes}.",
    "upload file": "Télécharger le fichier",
    "urgent_question": "Question urgente?",
    "view": "Vue",
    "write_answer": "Noter une réponse",
    "zabbix_link": "Network Monitoring"
  },
  "usage": {
    "cdr_download_failed": "Les enregistrements détaillés n'ont pas pu être téléchargés.",
    "cdr_month_too_old": "Les données de consommation ne peuvent être exportées que pour les trois derniers mois",
    "cdr_no_records": "Aucun enregistrement détaillé n'a été trouvé pour cette période.",
    "download_cdr": "Télécharger",
    "page_title": "Historique de consommation",
    "select_product": "Sélectionnez un produit",
    "select_type": "Sélectionnez un type de consommation"
  },
  "user": {
    "CustomerId": "Numéro de client",
    "ID": "ID",
    "account_settings": "Paramètres du compte",
    "billing": "Facturation",
    "explore": "Explorer",
    "faq": "FAQ",
    "helpAndSupport": "Help & Support",
    "language": "Changer la langue",
    "logout": "Se déconnecter",
    "profile": "Profile",
    "projects": "Projets",
    "settings": "Paramétres",
    "switch_to_fleetportal": "Passer au portail fleet"
  },
  "vuestic": {
    "noOptions": "Pas d'options disponibles",
    "search": "Recherche"
  }
}
